import { supabase } from '../utils/supabase';

const SESSION_ID_CHUNK = 100;
const PAGE_SIZE = 1000;

async function fetchSessionIdRows(table, sessionIds) {
  if (!sessionIds.length) return [];

  const chunks = [];
  for (let i = 0; i < sessionIds.length; i += SESSION_ID_CHUNK) {
    chunks.push(sessionIds.slice(i, i + SESSION_ID_CHUNK));
  }

  const chunkRows = await Promise.all(
    chunks.map(async (chunk) => {
      const rows = [];
      let from = 0;
      while (true) {
        const { data, error } = await supabase
          .from(table)
          .select('session_id')
          .in('session_id', chunk)
          .range(from, from + PAGE_SIZE - 1);

        if (error) {
          console.error(`[sessionActivityStats] ${table} count error:`, error);
          break;
        }

        rows.push(...(data || []));
        if (!data || data.length < PAGE_SIZE) break;
        from += PAGE_SIZE;
      }
      return rows;
    })
  );

  return chunkRows.flat();
}

export async function fetchSessionActivityCountMap(sessionIds) {
  if (!sessionIds.length) return {};

  const gamesCountBySession = {};
  const playersCountBySession = {};
  sessionIds.forEach((id) => {
    gamesCountBySession[id] = 0;
    playersCountBySession[id] = 0;
  });

  const [gameRows, playerRows] = await Promise.all([
    fetchSessionIdRows('session_games', sessionIds),
    fetchSessionIdRows('session_players', sessionIds),
  ]);

  gameRows.forEach((row) => {
    if (row.session_id) {
      gamesCountBySession[row.session_id] = (gamesCountBySession[row.session_id] || 0) + 1;
    }
  });

  playerRows.forEach((row) => {
    if (row.session_id) {
      playersCountBySession[row.session_id] = (playersCountBySession[row.session_id] || 0) + 1;
    }
  });

  const map = {};
  sessionIds.forEach((id) => {
    map[id] = {
      games_count: gamesCountBySession[id] ?? 0,
      players_count: playersCountBySession[id] ?? 0,
    };
  });
  return map;
}

export function mergeSessionActivityCounts(sessions, countMap) {
  if (!sessions?.length) return sessions || [];
  return sessions.map((session) => {
    const counts = countMap[session.id];
    return counts ? { ...session, ...counts } : session;
  });
}
